import { View } from "@aws-amplify/ui-react";
import LearnMoreNav from "./LearnMoreNav";
import OriginStory from "./OriginStory";
import TheProblems from "./TheProblems";
import { PageEnder } from "./PageEnder";
import { TheSolutions } from "./TheSolutions";

export default function LearnMore() {
  return (
    <View
      position="relative"
      width="100%"
      height="100%"
      //   backgroundColor="#0C8645"
    >
      <div
        style={{
          backgroundImage:
            "radial-gradient(130% 100% at 0% 0%, #737373, #0C8645)",
        }}
        className="absolute h-[100%] w-full overflow-hidden"
      />
      <LearnMoreNav />
      <View className="relative flex flex-col pt-24">
        <OriginStory />
        <TheProblems />
        <TheSolutions />
        <PageEnder />
      </View>
    </View>
  );
}
